import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { t } from '../../../../../../i18n';
import myTeamUnitsActions from '../actions';
import myTeamSubunitsActions from '../../../../subUnits/subUnit/myTeam/actions';
import { TYPES } from './addApplicantModal';
import ApiInstance from '../../../../../../helpers/apiInstance';

const getMyTeamWorkersUnitApi = new ApiInstance('units/:id/team_members/workers/search');
const getMyTeamWorkersSubunitApi = new ApiInstance('subunits/:id/team_members/workers/search');
const addToMyTeamApi = new ApiInstance('companies/:id/company_team_members');

function* load({ payload }) {
  try {
    const { page = 1, pageSize = 5, filter = '', id, type } = payload;

    const apiInstance = type === TYPES.UNIT ? getMyTeamWorkersUnitApi : getMyTeamWorkersSubunitApi;

    const result = yield call(
      sendRequest,
      apiInstance.get,
      { search: { page, pageSize, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      const { records, totalCount } = result.data;

      yield put(
        actions.loadTalentsSuccess({
          records,
          totalCount,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addApplicantToMyTeamRequest({ payload }) {
  try {
    const { data, id, type } = payload;
    const result = yield call(
      sendRequest,
      addToMyTeamApi.post,
      { data, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      yield put(actions.closeModal());

      if (type === TYPES.UNIT) {
        yield put(myTeamUnitsActions.loadData({ id }));
      } else {
        yield put(myTeamSubunitsActions.loadData({ id }));
      }

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.units.unit.my_team.add_talent_modal.talent_added_successfully'),
        }),
      );
      yield put(actions.clearStore());
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_TALENT_REQUEST, load),
    takeEvery(actions.ADD_TALENT_TO_MY_TEAM_REQUEST, addApplicantToMyTeamRequest),
  ]);
}
